import React from "react"
import PropTypes from "prop-types"
import Caption from "./Caption"

/**
 * Full width image component
 */
const FullWidthImage = ({ slice }) => {
  const {
    image: { url: imageUrl },
    caption,
  } = slice.primary

  return (
    <div
      className="full-width-image single"
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <div className="wrapper">
        <Caption caption={caption} />
      </div>
    </div>
  )
}

FullWidthImage.propTypes = {
  slice: PropTypes.shape({
    primary: PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
        caption: PropTypes.string,
      }).isRequired,
      caption: PropTypes.string,
    }).isRequired,
    slice_label: PropTypes.string,
  }).isRequired,
}

export default FullWidthImage
